export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6302.62b6d813.jpg";